import { render, staticRenderFns } from "./GetADemo.vue?vue&type=template&id=b2650ffe"
import script from "./GetADemo.vue?vue&type=script&lang=js"
export * from "./GetADemo.vue?vue&type=script&lang=js"
import style0 from "./GetADemo.vue?vue&type=style&index=0&id=b2650ffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports